import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';

import { ReactComponent as SearchIcon } from '~/assets/images/search-icon.svg';
import type {
  DataTablePrimaryAction,
  DataTableSearchConfig,
} from '~/components/DataView/DataTable/utils/types';
import SearchBar from '~/components/VisionUI/SearchBar';

type DataTableActionsProps = {
  search?: DataTableSearchConfig | null;
  primaryAction?: DataTablePrimaryAction;
  searchPlaceholder: string;
};

const DataTableActions = ({
  search = null,
  primaryAction = undefined,
  searchPlaceholder,
}: DataTableActionsProps) => {
  const { value, onChange, 'data-testid': searchBarDataTestId } = search ?? {};
  const {
    onClick,
    'data-testid': primaryActionTestId,
    disabled,
    label,
  } = primaryAction ?? {};
  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      justifyContent="space-between"
      spacing={2}
      px={{ xs: 2, sm: 3 }}
      pt={3}
    >
      {search && onChange && (
        <SearchBar
          searchQuery={value}
          handleSearch={onChange}
          placeholder={searchPlaceholder}
          data-testid={searchBarDataTestId}
          searchIcon={<SearchIcon />}
        />
      )}

      {primaryAction && (
        <Button
          variant="contained"
          onClick={onClick}
          data-testid={primaryActionTestId}
          disabled={disabled}
          sx={{
            whiteSpace: 'nowrap',
            alignSelf: { xs: 'stretch', md: 'auto' },
          }}
        >
          {label}
        </Button>
      )}
    </Stack>
  );
};

export default DataTableActions;
